import { yupResolver } from "@hookform/resolvers/yup";
import { Box, DialogContent } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import useBrandSchema from "./utils/useBrandSchema";
import ReactHookFields from "../../components/shared/ReactHookForm";
import useBrandCreate from "../../hooks/brands/useBrandCreate";
import { enqueueSnackbar } from "notistack";
import useAppGlobal from "../../context/useAppGlobal";
import useBrandUpdate from "src/hooks/brands/useBrandUpdate";

export default function BrandCreate({ item }) {
  const { closeDialog } = useAppGlobal();
  const { trigger: createBrand } = useBrandCreate();
  const { trigger: updateBrand } = useBrandUpdate(item?._id);

  const { validationSchema, brandObject, brandFieldList } = useBrandSchema({ item });
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(validationSchema),
    defaultValues: brandObject,
    shouldUnregister: false,
  });

  const handleBrandCreate = async (data) => {
    let res;
    if (!item) {
      res = await createBrand({
        body: {
          ...data,
          manufacturer: data?.manufacturer?._id,
        },
      });
    } else {
      res = await updateBrand({
        body: {
          ...data,
          manufacturer: data?.manufacturer?._id,
        },
      });
    }
    if (res?.success) {
      reset();
      closeDialog();
      return enqueueSnackbar("Thành công!", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };

  return (
    <DialogContent>
      <Box py={2}>
        <ReactHookFields
          onSubmit={handleSubmit(handleBrandCreate)}
          listFields={brandFieldList}
          control={control}
          errors={errors}
          btnFullWidth={true}
        />
      </Box>
    </DialogContent>
  );
}
